import { IAjax } from 'lib/Ajax';

export interface IApiConventions<T> {
    formatUrl: (query: string) => string;
    getMatchesArray: (resp: T[]) => T[];
}

export interface IRequestQueue<T> {
    add: (query: string, cb: (items: T[]) => void) => void;
}

export interface ITypeaheadServerSide<T> {
    RequestQueue: (apiConventions: IApiConventions<T>) => IRequestQueue<T>;
    ApiConventions: (baseUrl: string) => IApiConventions<T>
}

export function TypeaheadServerSide<T>(ajax : IAjax) : ITypeaheadServerSide<T> {

    // Our custom transport layer for managing server-side typeahead searches.
    // This is in place of Twitter's Bloodhound, which feels bloated for our purposes. See https://github.com/twitter/typeahead.js/blob/master/doc/bloodhound.md
    return {
        RequestQueue: RequestQueue,
        ApiConventions: SearchApiConventions
    };

    // Pool search requests.
    // At most one request is in flight at a time.
    // When that request finishes, send the next request with the most recent query parameter.
    function RequestQueue(apiConventions : IApiConventions<T>) : IRequestQueue<T> {
        var sending = false, 
            nextQuery : string, 
            nextCb : (items : T[]) => void, 
            lastQuerySent : string;

        return { 
            add: add 
        };

        function add(query : string, cb : (items : T[]) => void) {
            nextQuery = query;
            nextCb = cb;
            if (!sending) _send();
        }

        function _send() {
            sending = true;
            lastQuerySent = nextQuery;
            ajax.Url<T[]>(apiConventions.formatUrl(nextQuery)).Get().then(_done(nextCb)).finally(function () {
                if (nextQuery !== lastQuerySent) _send();
                else sending = false;
            });
        }

        function _done(cb: (items : T[]) => void) {
            return function (resp : T[]){ cb(apiConventions.getMatchesArray(resp)); };
        }
    }

    // Our conventions for search endpoints
    function SearchApiConventions(baseUrl : string) : IApiConventions<T> {
        return {
            formatUrl: function (query : string) {
                // Convention - search endpoints should take the search term as the q parameter in the query string
                return baseUrl + '?q=' + encodeURIComponent(query);
            },
            getMatchesArray: function (resp : T[]) {
                // Convention - search endpoints should return an array of match objects
                return resp;
            }
        };
    }
}


// WEBPACK FOOTER //
// ./apps/portcall/typeahead/typeahead-server-side.ts